import { render, staticRenderFns } from "./CompanyIntegrationSetting.vue?vue&type=template&id=ff629e52&scoped=true"
import script from "./CompanyIntegrationSetting.vue?vue&type=script&lang=js"
export * from "./CompanyIntegrationSetting.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntegrationSetting.vue?vue&type=style&index=0&id=ff629e52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff629e52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff629e52')) {
      api.createRecord('ff629e52', component.options)
    } else {
      api.reload('ff629e52', component.options)
    }
    module.hot.accept("./CompanyIntegrationSetting.vue?vue&type=template&id=ff629e52&scoped=true", function () {
      api.rerender('ff629e52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/CompanyIntegrationSetting.vue"
export default component.exports